export default __webpack_public_path__ + "static/media/wallet.0d4f84c2.svg";